import axiosInstance from "../AxiosInstance";

// Type definitions
interface DownloadParams {
    [key: string]: string | number | boolean | string[] | number[] | undefined;
}

type SetLoadingFunction = (loading: boolean) => void;
type SetErrorFunction = (error: string | null) => void;

interface DownloadOptions {
    paramsSerializer?: { indexes: null };
    signal?: AbortSignal;
}

export const downloadCsv = async (
    url: string, 
    params: DownloadParams, 
    fileName: string, 
    setLoading: SetLoadingFunction,
    setError?: SetErrorFunction,
    options: DownloadOptions = {}
): Promise<void> => {
    setLoading(true);

    try {
        const response = await axiosInstance.get(url, {
            params,
            responseType: 'blob',
            ...options
        });

        if (options.signal?.aborted) {
            return;
        }

        const blob = new Blob([response.data]);
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        // Clean up the object URL to prevent memory leaks
        window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
        if (options.signal?.aborted) {
            return;
        }

        console.error("Failed to download CSV:", error);
        setError?.("Failed to download CSV. Please try again later.");
    } finally {
        setLoading(false);
    }
};

// Export types for use in other files
export type { DownloadParams, SetLoadingFunction, SetErrorFunction, DownloadOptions };
